import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = ''
    switch (payload.event.context.userLogged.roles[0].id) {
      case 1:
      url = 'inspection-company';
      break;
      case 2: url = 'inspections-company' 
      break
      case 3:
      case 4:
        url = 'inspections-user'
        break
      default: url = 'inspections-user'
        break
    }
    let options = {
      emulateJSON: false
    }
    let params = {};
    if (payload.event.context.userLogged.roles[0].id === 1) {
      params = {
        "perPage": payload.event.perPage,
        "page": payload.event.page,
        "ord": payload.event.ord,
        "company_id": payload.event.filter.company_id ? payload.event.filter.company_id : undefined,
        "start_date": payload.event.filter.dateRange && payload.event.filter.start_date 
          ? payload.event.filter.start_date : undefined,
        "end_date": payload.event.filter.dateRange && payload.event.filter.end_date 
          ? payload.event.filter.end_date : undefined 
      };
    } else {
      params = {
        "perPage": payload.event.perPage,
        "page": payload.event.page,
        "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
        "ord": payload.event.ord,
        "type": payload.event.type,
        "unit_type_id": payload.event.filter.unit_type_id ? payload.event.filter.unit_type_id : undefined,
        "unit_number": payload.event.filter.unit_number ? payload.event.filter.unit_number : undefined,
        "vin_number": payload.event.filter.vin_number ? payload.event.filter.vin_number : undefined,
        "plate": payload.event.filter.plate ? payload.event.filter.plate : undefined,
        "site_id": payload.event.filter.site_id ? payload.event.filter.site_id : undefined,
        "transit": payload.event.filter.type_transit ? payload.event.filter.type_transit : undefined,
        "start_date": payload.event.filter.dateRange && payload.event.filter.start_date 
          ? payload.event.filter.start_date : undefined,
        "end_date": payload.event.filter.dateRange && payload.event.filter.end_date 
          ? payload.event.filter.end_date : undefined
    }
    }
    http.get(url, {params: params}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getTotal ({commit}, payload) {
    let url = 'inspections-total'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey[0] : undefined,
      "ord": payload.event.ord && payload.event.ord[0] ? 'desc' : 'asc',
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }
    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getOperatorValidate({commit}, payload) {
    let url = `operator-validated`
    
    let params = { "inspection_id": payload.event.id }
    
    let options = { emulateJSON: false }

    http.get(url, {params}, options)
      .then(
        response => {
          commit('onGetOperatorValidate', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getById ({commit}, payload) {
    let url = `inspection/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getPdf ({commit}, payload) {
    let url = `pdf-generate/${payload.event.id}`
    // let url = `pdf-generate/${payload.event.id}?force_generate=1` // ELIMINAR PARA PRODUCCIÓN, SOLO PRUEBAS

    http.get(url, {responseType: 'blob'})
      .then(
        response => {
          commit('onGetPdf', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = `inspection/${payload.event.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit ('onDelete', {event: payload.event, response})
        },
        error => {
          commit ('onError', {event: payload.event, error})
        }
      )
  },
  getReports ({ commit }, payload) {
    let url = 'pdf-zip-generate'
    let inspections = payload.event.inspections
    http.post(url, { inspections }, {responseType: 'blob'})
      .then(
        response => {
          commit('onGetReports', {event: payload.event, response})
        },
        error => {
          commit ('onError', {event: payload.event, error})
        }
      ) 
  },
  getDamagePercentage({ commit }, payload) {
    let url = "dasboard/damage-percentage";
    let options = {
      emulateJSON: false,
      headers: {
        "Content-Type": "application/json",
      },
    };
    let params = {
      start_date: payload.event.start_date,
      end_date: payload.event.end_date,
    };

    http
      .get(url, { params }, options)
      .then((response) => {
        commit("onGetDamagePercentage", { event: payload.event, response });
      })
      .catch((error) => {
        commit("onError", { event: payload.event, error });
      });
  },
  getTopSites({ commit }, payload) {
    const url = "dasboard/sites-top";
    const options = {
      emulateJSON: false,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const params = {
      start_date: payload.event.start_date,
      end_date: payload.event.end_date,
    };
    http
      .get(url, { params }, options)
      .then((response) => {
        commit("onGetTopSites", { event: payload.event, response });
      })
      .catch((error) => {
        commit("onError", { event: payload.event, error });
      });
  },
  getInspectionClassifications({ commit }, payload) {
    const url = 'dasboard/inspections-count';
    const params = {
      start_date: payload.event.filter.start_date,
      end_date: payload.event.filter.end_date,
      perPage: -1,
      page: 1
    };

    return http.get(url, { params })
      .then(response => {
        commit('onGetInspectionClassifications', response.data.data.data);
      })
      .catch(error => {
        throw error;
      });
  },
  getInspectionLineData({ commit }, payload) {
    const url = 'dasboard/inspections';
    const options = {
      emulateJSON: false
    };
    const params = {
      start_date: payload.event.filter.start_date,
      end_date: payload.event.filter.end_date
    };

    return http.get(url, { params }, options)
      .then(response => {
        commit('onGetInspectionLineData', response.data.data);
      })
      .catch(error => {
        commit('onError', error);
        throw error;
      });
  },
  getInspectionIndicators({ commit }, payload) {
    const url = 'dasboard/inspections-indicators';
    const options = {
      emulateJSON: false
    };
    const params = {
      start_date: payload.event.filter.start_date || null,
      end_date: payload.event.filter.end_date || null,
      site_id: payload.event.filter.site_id || null,
      user_id: payload.event.filter.user_id || null,
      unit_type_id: payload.event.filter.unit_type_id || null,
    };

    return http.get(url, { params }, options)
      .then(response => {
        commit('onGetInspectionIndicators', response.data.data);
      })
      .catch(error => {
        commit('onError', error);
        throw error;
      });
  },
  getInspectionPointsDamaged({ commit }, payload) {
    const url = "inspection-points/damaged";
    const options = {
      emulateJSON: false,
      headers: {
        "Content-Type": "application/json",
      },
    };
  
    const params = {
      date_start: payload.event.start_date, 
      date_end: payload.event.end_date,
      perPage: 10,
      ord: 'DESC',
      type: 'json'
    };

    return http
      .get(url, { params }, options)
      .then((response) => {
        commit("onGetInspectionPointsDamaged", { event: payload.event, response });
      })
      .catch((error) => {
        commit("onError", { event: payload.event, error });
        throw error;
      });
  },
  getOperatorCountDamaged({ commit }, payload) {
    const url = "operator-count-damaged";
    const options = {
      emulateJSON: false,
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const params = {
      date_start: payload.event.start_date, 
      date_end: payload.event.end_date,
      perPage: 10,
      type: 'json'
    };

    return http
      .get(url, { params }, options)
      .then((response) => {
        commit("onGetOperatorCountDamaged", { event: payload.event, response });
      })
      .catch((error) => {
        commit("onError", { event: payload.event, error });
        throw error;
      });
  },
  getDamageFrequencyByUnit({ commit }, payload) {
    const url = "report-unit-index";
    const options = {
      emulateJSON: false,
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const params = {
      date_start: payload.event.start_date, 
      date_end: payload.event.end_date,
      perPage: 10,
      ord: 'DESC',
      type: 'json'
    };

    return http
      .get(url, { params }, options)
      .then((response) => {
        commit("onGetDamageFrequencyByUnit", { event: payload.event, response });
      })
      .catch((error) => {
        commit("onError", { event: payload.event, error });
        throw error;
      });
  },
}

export default actions